import { ACCOUNTTYPES } from 'src/settings/registration';
import IdentityVerificationFormIndividual from './IdentityVerificationFormIndividual';
import IdentityVerificationFormMinor from './IdentityVerificationFormMinor';
import IdentityVerificationFormSmsf from './IdentityVerificationFormSmsf';
import IdentityVerificationFormAdvisor from './IdentityVerificationFormAdvisor';

const IdentityVerificationForm = (props) => {
  if (props.user) {
    if (props.user.accountType === ACCOUNTTYPES.MINOR.toUpperCase()) {
      return <IdentityVerificationFormMinor {...props} />;
    }
    if (props.user.accountType === ACCOUNTTYPES.SMSF.toUpperCase()) {
      return <IdentityVerificationFormSmsf {...props} />;
    }
    if (props.user.accountType === ACCOUNTTYPES.TRUST.toUpperCase()) {
      return <IdentityVerificationFormSmsf {...props} />;
    }
    if (props.user.accountType === ACCOUNTTYPES.CORPORATION.toUpperCase()) {
      return <IdentityVerificationFormSmsf {...props} />;
    }
    if (props.user.accountType === ACCOUNTTYPES.ADVISOR.toUpperCase()) {
      return <IdentityVerificationFormAdvisor {...props} />;
    }
    return <IdentityVerificationFormIndividual {...props} />;
  }
};

export default IdentityVerificationForm;
